import React from "react";
import { Link } from "react-router-dom";
import { statusColorMap, statusLabelMap } from "src/constants";
import { Status } from "src/types";
import { ChevronRight } from "lucide-react";

interface StatusPillProps {
  status: Status;
  linkPath?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, linkPath }) => {
  const color = statusColorMap[status] || "grey";
  const label = statusLabelMap[status] ?? status;

  // Map colors to Tailwind classes
  const colorClasses: Record<string, string> = {
    grey: "text-gray-500 border-gray-500",
    blue: "text-blue-600 border-blue-600",
    green: "text-green-600 border-green-600",
    orange: "text-orange-500 border-orange-500",
    red: "text-red-600 border-red-600",
    yellow: "text-yellow-600 border-yellow-600",
    purple: "text-purple-600 border-purple-600"
  };

  const colorClass = colorClasses[color] || colorClasses.grey;

  if (linkPath) {
    return (
      <Link to={linkPath} className="group inline-block hover:opacity-80 transition-opacity">
        <span
          className={`inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-medium capitalize whitespace-nowrap bg-transparent border cursor-pointer ${colorClass}`}
        >
          {label}
          <ChevronRight className="w-3 h-3 ml-1.5 transition-transform group-hover:translate-x-0.5" />
        </span>
      </Link>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-medium capitalize whitespace-nowrap bg-transparent border ${colorClass}`}
    >
      {label}
    </span>
  );
};
